const marketplaceProviders = ['aws', 'azure', 'trendmicro'];

/**
 * Return C1C_MarketplaceRequest Object Details
 * @returns {any}
 */
const getMarketplaceObjFromStorage = () =>
  JSON.parse(localStorage.getItem('C1C_MarketplaceRequest') || '{}');

export function useMarketplaceDetails() {
  const { provider = '', token = '' } = getMarketplaceObjFromStorage();
  const matchedProvider =
    marketplaceProviders.find((service) => provider.toLowerCase().startsWith(service)) || '';

  return {
    marketplaceProvider: matchedProvider,
    marketplaceToken: token,
  };
}
